// @flow
import * as R from "ramda"
import type { Combination, PassengerGroup } from "@kiwicom/nitro/lib/records/Baggage"

// eslint-disable-next-line import/prefer-default-export
export const getGroupCombinations = (group: PassengerGroup) =>
  // $FlowFixMe
  R.filter<Combination>(comb => (comb.conditions.passengerGroups || []).includes(group))
